import React from 'react';
import IntlComponent from 'axway-react-intl';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../actions';
import GenerateEndpointsDialog from '../view/GenerateEndpointsDialog';

class GenerateEndpoints extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.closeDialog = this.closeDialog.bind(this);
		this.generateEndpoints = this.generateEndpoints.bind(this);
	}
	render() {
		return (
			<GenerateEndpointsDialog
				modelForEndpoint={this.props.modelForEndpoint}
				endpointLocation={this.props.endpointLocation}
				generateSuccess={this.props.generateSuccess}
				closeDialog={this.closeDialog}
				generateEndpoints={this.generateEndpoints}
			/>
		);
	}
	closeDialog() {
		this.props.actions.confirmGenerateEndpoints({
			payload: null
		});
	}
	generateEndpoints() {
		const name = this.props.modelForEndpoint && this.props.modelForEndpoint.name;
		this.props.actions.generateEndpoints(name);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

function mapStateToProps(state) {
	return {
		modelForEndpoint: state.models.modelForEndpoint,
		generateSuccess: state.models.generateSuccess,
		endpointLocation: state.models.endpointLocation
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(GenerateEndpoints);
